/**
 * Inside Your Kit Custom Element
 * Self-initializing, editor-friendly web component wrapping the kit items grid/carousel.
 */
class InsideYourKit extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('.inside-your-kit__grid.is-carousel');
    if (!this.carousel) return;
    
    // Bind slick initialization
    this.initSlick();
    
    // Handle resizing smoothly using ResizeObserver
    this.resizeObserver = new ResizeObserver(() => {
      this.initSlick();
    });
    this.resizeObserver.observe(this);

    // Mobile tap handler for description overlays
    this.addEventListener('click', (e) => {
      const item = e.target.closest('.inside-your-kit__item');
      if (item && window.innerWidth < 990) {
        const isActive = item.classList.contains('is-active');
        this.querySelectorAll('.inside-your-kit__item').forEach(el => el.classList.remove('is-active'));
        if (!isActive) {
          item.classList.add('is-active');
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initSlick() {
    const $carousel = $(this.carousel);
    if (window.innerWidth < 990) {
      if ($carousel.length > 0 && !$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          dots: true,
          infinite: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    } else {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
  }
}

if (!customElements.get('inside-your-kit')) {
  customElements.define('inside-your-kit', InsideYourKit);
}
